/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import React from "react";
import IconBerserkerMail from "../Icon";

const ToastContainer = styled.div`
  display: flex;
  align-items: center;
  background: #333333;
  border-radius: 2px;
  width: 100%;
  height: 100%;
  padding: 0px 10px;
`;

const Content = styled.div`
  color: #fff;
`;

const Options = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Action = styled.div`
  color: #fb972e;
  margin: 0px 10px;
  cursor: pointer;

  :first-of-type {
    padding-left: 5px;
  }
`;

const EmailSentContainer = styled.div`
  display: flex;
  align-items: center;
`;

const ToastContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Icon = styled.div`
  margin-right: 10px;
`;

interface Props {
  text: string;
  deselect: () => void;
}

export default function ContactsSelected(props: Props) {
  const { text, deselect } = props;

  return (
    <ToastContainer>
      <ToastContent>
        <EmailSentContainer>
          <Icon>
            <IconBerserkerMail
              name="contacts-selected"
              width={20}
              height={20}
            />
          </Icon>
          <Content>{text}</Content>
        </EmailSentContainer>

        <Options>
          <Action onClick={deselect}>Deselect</Action>
        </Options>
      </ToastContent>
    </ToastContainer>
  );
}
